import logger from '../../util/logger';
import { intl } from '../Intl/IntlGlobalWrapper';

// Export Constants
export const SET_ERROR = 'SET_ERROR';
export const SET_SUCCESS = 'SET_SUCCESS';
export const CLEAN = 'CLEAN';

const DEFAULT_SETTINGS = { log: true, show: true };

function formatMessage(msg) {
  let message = msg;
  if (msg.data || (msg.message && msg.message.indexOf('error.') > -1)) {
    message = '';

    if (msg.data) {
      Object.keys(msg.data).map(function(key, index) {
        message += intl.formatMessage({ id: msg.data[key].msg }, msg.data[key].vals) + '\r\n';
      });
    } else {
      message += intl.formatMessage({ id: msg.message }) + '\r\n';
    }

    if (!message) {
      message = msg;
    }
  }

  if (msg instanceof Error) {
    message = msg.toString();
  }

  return message;
}

// Export Actions
export function setError(err, opt) {
  opt = {
    ...DEFAULT_SETTINGS,
    ...opt
  };

  if (!err) {
    return clean();
  }

  let message = formatMessage(err);

  if (opt.log) {
    console.error(err);
    logger.error(message, {
      ...opt.details,
      stacktrace: err instanceof Error ? err.stack : ''
    });
  }

  if (!opt.show) {
    return { type: CLEAN };
  }

  return {
    type: SET_ERROR,
    error: message
  };
}

export function setSuccessMessage(msg, opt) {
  let message = formatMessage(msg);
  return {
    type: SET_SUCCESS,
    msg: message,
    opt
  };
}

export function clean() {
  return { type: CLEAN };
}
